// extracted by mini-css-extract-plugin
export default {"loader":"loader_loader__qZv+U","circular-spin":"loader_circular-spin__CK+R8"};